














































































































import { Component, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Login } from '@/data/models/login.model';
import { AuthService } from '@/data/services/auth.service';
import { BaseError } from '@/data/models/error.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class LoginComponent extends Vue {
	@Inject('AuthService') authService!: AuthService;

	username: string = '';
	password: string = '';

	error?: string = '';

	loading: boolean = false;
	isModalOpen: boolean = false;
	newEmail: string = '';

	forgotPassword() {
		this.isModalOpen = true;
		this.newEmail = '';
	}

	sendResetReq() {
		const email = this.newEmail;
		this.authService.resetPasswordRequest({ email }).then(res => {
			this.isModalOpen = false;
			this.$buefy.notification.open({
				message: res.msg as string,
				type: 'is-success',
			});
		}).catch(({ data }: { data: BaseError}) => {
			this.$buefy.notification.open({
				message: data.msg,
				type: 'is-danger',
			});
		}).finally(() => this.loading = false);

	}

	submit() {
		this.loading = true;
		const login = new Login();
		login.username = this.username;
		login.md5password = this.password;
		this.authService
			.login(login)
			.then(() => {
				const redirect = (this.$route.query.redirect as string) || '/';
				this.$router.push({ path: redirect });
			})
			.catch(({ data }: { data: BaseError}) => {
				this.error = data.msg;
			}).finally(() => this.loading = false);
	}
}
